import { Loader } from "sui";

import { i18n } from "@lib/i18n";
import { globalLayoutRoute } from "@routes";
import { allowAdminAndUser, requireScope } from "@routes/authorization";
import { createRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";

export const settingsRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `settings`,
    component: lazyRouteComponent(() => import("./index")),
    beforeLoad: async () => {
        const allowedAdminAndUser = await allowAdminAndUser();
        if (allowedAdminAndUser) {
            requireScope("accountOrNetwork");
        }

        return { getTitle: () => i18n.doc_title_settings() };
    },
});
export const settingsIndexRoute = createRoute({
    getParentRoute: () => settingsRoute,
    path: `/`,
    beforeLoad: () => {
        throw redirect({ to: `/settings/legal` });
    },
});

export const legalInformationRoute = createRoute({
    getParentRoute: () => settingsRoute,
    path: `legal`,
    component: lazyRouteComponent(
        () => import("./components/LegalInformation"),
        "LegalInformation",
    ),
    beforeLoad: () => requireScope("account"),
    pendingComponent: () => (
        <div className='flex justify-center text-[var(--sui-blue-500)]'>
            <Loader />
        </div>
    ),
});
export const paymentInformationRoute = createRoute({
    getParentRoute: () => settingsRoute,
    path: `payment`,
    component: lazyRouteComponent(() => import("./PaymentInformation"), "PaymentInformation"),
    beforeLoad: () => requireScope("account"),
    pendingComponent: () => (
        <div className='flex justify-center text-[var(--sui-blue-500)]'>
            <Loader />
        </div>
    ),
});
export const remunerationInformationRoute = createRoute({
    getParentRoute: () => settingsRoute,
    path: `remuneration`,
    component: lazyRouteComponent(() => import("./containers/RemunerationInformation")),
    beforeLoad: () => requireScope("account"),
});
export const profileRoute = createRoute({
    getParentRoute: () => settingsRoute,
    path: `profile`,
    component: lazyRouteComponent(() => import("@pages/settings-profile"), "SettingsProfilePage"),
    beforeLoad: () => requireScope("account"),
    pendingComponent: () => (
        <div className='grid h-full w-full place-items-center text-blue-500'>
            <Loader />
        </div>
    ),
});
export const teamSettingsRoute = createRoute({
    getParentRoute: () => settingsRoute,
    path: `team`,
    component: lazyRouteComponent(() => import("./Team/Team")),
    beforeLoad: () => requireScope("accountOrNetwork"),
});
export const departmentsSettingsRoute = createRoute({
    getParentRoute: () => settingsRoute,
    path: "departments",
    component: lazyRouteComponent(() => import("./Departments/Departments"), "Departments"),
    beforeLoad: () => requireScope("account"),
    pendingComponent: () => (
        <div className='grid h-full w-full place-items-center text-blue-500'>
            <Loader />
        </div>
    ),
});
